export class FleetAggregation  {

    constructor(jsonObject: any) {
        this.title = jsonObject.title;
        this.count = jsonObject.count;
    }

    title: string;
    count: number;
}